const Builder = require('../BuilderBase');
const Form = require('../Form');
const SingleRecordForm = require('../SingleRecordForm');
const Layout = require('../Layout');
const DetailPane = require('../DetailPane');
const GreedySectionLayout = require('../GreedyLayout');
const SearchPane = require('../SearchPane');
const Blockly = require('blockly');
const SummaryDetailLayout = require('../layouts/SummaryDetailLayout');
const HiddenFor = require('../HiddenFor');
const CustomizableVisibility = require('../CustomizableVisibility');

module.exports = class TestTree extends Builder {
    constructor(title, properties, namespaces, pageType = 'page_Page') {
        super(pageType, title, properties, namespaces);
        // Avoid irrelevant validation error.
        Blockly.FieldDropdown.prototype.doClassValidation_ = val => val;
    }

    layout(options) {
        const layout = new Layout('testLayout');
        this.addChildBlock(layout, undefined, options);
        return layout;
    }

    greedySectionLayout() {
        let layout = new GreedySectionLayout('testLayout');
        this.addChildBlock(layout);
        return layout;
    }

    summaryDetailLayout(title, properties) {
        let propertyKeys = Object.keys(properties);
        if (!propertyKeys.includes('defaultNamespace') || !propertyKeys.includes('defaultRelation')) {
            throw new Error(
                'You must specify "defaultNamespace" and "defaultRelation" properties for the Summary Detail Layout'
            );
        }
        const layout = new Layout('testLayout');
        this.addChildBlock(layout);
        const summaryDetailLayout = new SummaryDetailLayout(title, properties);
        layout.addChildBlock(summaryDetailLayout);

        return summaryDetailLayout;
    }

    detailPane(forAction, properties, options) {
        if (typeof properties === 'string') {
            throw new Error('do NOT pass in a title (first argument)');
        }
        const propertyKeys = Object.keys(properties);
        if (!forAction) {
            throw new Error('You must specify a "forAction" on the test tree Detail Pane constructor.');
        }
        if (!propertyKeys.includes('namespace') || !propertyKeys.includes('relation')) {
            throw new Error('You must specify "namespace" and "relation" properties for the Detail Pane');
        }

        const layout = new Layout('testLayout');
        this.addChildBlock(layout);

        const detailPane = new DetailPane('testDetailPane', {
            namespace: properties.namespace,
            relation: properties.relation,
            forAction: forAction
        });
        layout.addChildBlock(detailPane, undefined, options);

        return detailPane;
    }

    form(title, forAction, properties = {}) {
        if (!forAction) {
            throw new Error(
                'You must specify a "forAction" on the test tree form constructor because it adds a detail pane on your behalf.'
            );
        }
        let propertyKeys = Object.keys(properties);
        if (!propertyKeys.includes('namespace') || !propertyKeys.includes('relation')) {
            throw new Error('You must specify "namespace" and "relation" properties for the Form');
        }

        let layout = new Layout('testLayout', {
            defaultNamespace: properties.namespace,
            defaultRelation: properties.relation
        });

        this.addChildBlock(layout);

        let detailPane = new DetailPane('testDetailPane', {
            namespace: properties.namespace,
            relation: properties.relation,
            forAction: forAction
        });
        layout.addChildBlock(detailPane);

        let form = new Form(title, properties);
        detailPane.addChildBlock(form);
        return form;
    }

    singleRecordForm(title, properties = {}) {
        let propertyKeys = Object.keys(properties);
        if (!propertyKeys.includes('namespace') || !propertyKeys.includes('relation')) {
            throw new Error('You must specify "namespace" and "relation" properties for the Form');
        }

        let layout = new Layout('testLayout', {
            defaultNamespace: properties.namespace,
            defaultRelation: properties.relation
        });

        this.addChildBlock(layout);

        let singleRecordForm = new SingleRecordForm(title, properties);
        layout.addChildBlock(singleRecordForm);
        return singleRecordForm;
    }

    searchPane(title, properties) {
        let propertyKeys = Object.keys(properties);
        if (!propertyKeys.includes('namespace') || !propertyKeys.includes('relation')) {
            throw new Error('You must specify "namespace" and "relation" properties for the Form');
        }

        let layout = new Layout('testLayout');
        this.addChildBlock(layout);

        let searchPane = new SearchPane('testSearchPane', {
            namespace: properties.namespace,
            relation: properties.relation,
            title: title
        });
        layout.addChildBlock(searchPane);

        return searchPane;
    }

    /**
     *
     * @param {string} role
     * @returns
     */
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} [properties.isTabAccess]
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility({ isTabAccess: false, ...properties });
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }
};
